var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-63b9935f-4555-4973-af55-1322b66c8b57",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-84720b8f-9821-407c-b5a5-da6ec7cc1d9e {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-84720b8f-9821-407c-b5a5-da6ec7cc1d9e",
    d: "M15.36,19.4c-.2,0-.39-.08-.54-.23-.01-.01-1.17-1.2-1.76-1.73-.31-.28-.33-.75-.06-1.06.28-.31.75-.33,1.06-.06.29.26.71.67,1.07,1.03.58-1.2,1.63-3.21,2.73-4.5.27-.32.74-.35,1.06-.08.32.27.35.74.08,1.06-1.47,1.72-2.94,5.09-2.95,5.12-.1.23-.31.39-.55.44-.04,0-.09.01-.13.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-84720b8f-9821-407c-b5a5-da6ec7cc1d9e",
    d: "M16,11c2.76,0,5,2.24,5,5s-2.24,5-5,5-5-2.24-5-5,2.24-5,5-5M16,9c-3.87,0-7,3.13-7,7s3.13,7,7,7,7-3.13,7-7-3.13-7-7-7h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.bed882dff583f46b18588e841e9b55b4.svg";
export { ForwardRef as ReactComponent };